<template lang="pug">
    div
        Card.card-shadow
            p(slot="title")
                Icon(type="md-funnel")
                |
                | Resources
            p(slot="extra") Quickly find your resources
            Form(:model="formData" label-position="left" :label-width="180")
                FormItem(label="Choose resource type")
                    FormSelect(
                        v-model="formData.esIndex"
                        :formData="formData"
                        :formItem="esIndexSelectorOptions"
                    )
                FormItem(label="Select a group (Optional)")
                    FormSelect(
                        v-model="formData.groupName"
                        :formData="formData"
                        :formItem="groupNameSelectorOptions"
                    )
                FormItem(label="Item name (Optional)")
                   FormInput(
                       v-model="formData.itemName"
                       :formData="formData"
                       :formItem="itemNameInputOptions"
                   )
                FormItem
                    Button(@click="getItems") Search

            RcmTable(
                :key="rcmTableKey"
                :esIndex="formData.esIndex"
                :esIndexFields="esIndexFields"
                :userCanCreate="false"
                :userCanIndex="false"
                :userCanDelete="false"
                :actionInTable="true"
                :userCanBatchEdit="false"
                :userCanBatchDelete="false"
                :userCanSearchByTag="false"
                :userCanExport="true"
                :userCanEditColumns="false"
                :userCanEditFilters="false"
                :userCanToggleFuzzySearch="false"
                :userCanChangeTablePage="false"
                :userCanAdjustTableSize="false"
                :sort="sort"
                :externalSearchFilters="searchFilters"
                ref="RcmTable"
            )
</template>
<script>
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";
import FormInput from "@/components/rcmTableFormItems/Input";
import VirtualTable from "@/components/VirtualTable";
import RcmTable from "@/components/RcmTable_v2";
import LinkExtend from "@/components/LinkExtend";
import { getFormOptions } from "@/api/formoptions";
import { updateDescription } from "@/api/esdata";

import Vue from "vue";
Vue.component("LinkExtend", LinkExtend);

import bus from "@/libs/bus.js";
export default {
    name: "ResourceFinder",
    props: [],
    components: { FormSelect, FormInput, VirtualTable, RcmTable, LinkExtend },
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            formData: {
                esIndex: "rcm-nginxconfigs",
                groupName: this.$store.state.queryGroupName == "all" ? "*" : this.$store.state.queryGroupName,
                itemName: "",
                tags: [],
            },
            esIndexSelectorOptions: {
                // placeholder: this.$i18n.t("domainsetting.groupName"),
                // options: [
                //     { label: this.$i18n.t("domainsetting.servername"), value: "rcm-nginxconfigs" },
                //     { label: this.$i18n.t("domainsetting.appProfileName"), value: "rcm-app-profiles" },
                //     { label: this.$i18n.t("domainsetting.usedWafRules"), value: "rcm-wafrules" },
                //     { label: this.$i18n.t("domainsetting.serviceGroupName"), value: "rcm-servicegroup" }
                // ]
                remoteOptions: async (queryValue, queryParams) => {
                    queryValue = queryValue || "*";
                    queryParams.resourceType = `*${queryValue}*`;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/resource-type?${queryString}`);
                    return result.data.options;
                },
                // defaultVal: "rcm-nginxconfigs"
            },
            groupNameSelectorOptions: {
                // placeholder: this.$i18n.t("domainsetting.groupName"),
                options: [
                    { label: "all", value: "*" },
                    ...this.$store.state.userData.inGroupsRole.map((e) => e.groupName),
                ],
                // defaultVal: this.$store.state.queryGroupName == "all" ? "*" : this.$store.state.queryGroupName,
                disabled: this.$store.state.queryGroupName !== "all",
            },
            itemNameInputOptions: {
                placeholder: "Item name",
            },
            sort: [{ modifiedDate: { order: "desc" } }],
            fields: {
                groupName: {
                    showInTable: true,
                    withForm: false,
                    render: (h, params) => {
                        return h(
                            "a",
                            {
                                on: {
                                    click: () => {
                                        bus.$emit("SET_QUERY_GROUPNAME", params.row.groupName);
                                    },
                                },
                            },
                            params.row.groupName
                        );
                    },
                },
                servername: {
                    showInTable: true,
                    withForm: false,
                    render: (h, params) => {
                        let { groupName, servername, appProfileName } = params.row;
                        let toPageName = appProfileName == "none" ? "NoneProfileDomainSetting" : "ProfileDomain";
                        let toParams = toPageName == "ProfileDomain" ? { appProfileName } : {};

                        let routeParams = {
                            name: toPageName,
                            params: toParams,
                            query: { groupName, servername },
                        };
                        return h(
                            "LinkExtend",
                            {
                                props: {
                                    routeParams,
                                },
                            },
                            servername
                        );
                    },
                },
                appProfileName: {
                    showInTable: true,
                    withForm: false,
                    render: (h, params) => {
                        let { groupName, servername, appProfileName } = params.row;
                        let elTag = appProfileName == "none" ? "p" : "LinkExtend";
                        let toPageName = "AppProfile";
                        let toParams = {};

                        let routeParams = {
                            name: toPageName,
                            params: toParams,
                            query: { groupName, appProfileName },
                        };

                        return h(
                            elTag,
                            {
                                props: {
                                    routeParams,
                                },
                            },
                            appProfileName
                        );
                    },
                },
                ruleName: {
                    showInTable: true,
                    withForm: false,
                    render: (h, params) => {
                        let { groupName, ruleName } = params.row;
                        let toPageName = "WafRules";
                        let toParams = {};

                        let routeParams = {
                            name: toPageName,
                            params: toParams,
                            query: { groupName, ruleName },
                        };

                        return h(
                            "LinkExtend",
                            {
                                props: {
                                    routeParams,
                                },
                            },
                            ruleName
                        );
                    },
                },
                serviceGroupName: {
                    showInTable: true,
                    withForm: false,
                    render: (h, params) => {
                        let { groupName, serviceGroupName } = params.row;
                        let toPageName = "ServiceGroup";
                        let toParams = {};

                        let routeParams = {
                            name: toPageName,
                            params: toParams,
                            query: { groupName, serviceGroupName },
                        };

                        return h(
                            "LinkExtend",
                            {
                                props: {
                                    routeParams,
                                },
                            },
                            serviceGroupName
                        );
                    },
                },
            },
            rcmTableKey: 0,
        };
    },
    methods: {
        getItems() {
            // this.rcmTableKey += 1;
            this.$refs.RcmTable.getTableData();
            // var self = this
            // this.isTableAlive = false;
            // this.$nextTick(() => {
            //     self.isTableAlive = true;
            // });
        },
        toIndexKeyName(esIndex) {
            let keyNameMap = {
                "rcm-nginxconfigs": "servername",
                "rcm-app-profiles": "appProfileName",
                "rcm-wafrules": "ruleName",
                "rcm-servicegroup": "serviceGroupName",
            };
            return keyNameMap[esIndex];
        },
    },
    computed: {
        searchFilters() {
            let filters = [];
            let { esIndex, groupName, tags, itemName } = this.formData;
            if (groupName.length > 0) {
                filters.push({
                    key: "groupName",
                    type: "string",
                    value: groupName,
                });
            }
            if (tags.length > 0) {
                filters.push({
                    key: "tags",
                    type: "string",
                    value: tags,
                });
            }
            if (itemName.length > 0) {
                filters.push({
                    key: this.toIndexKeyName(esIndex),
                    type: "string",
                    value: itemName,
                });
            }
            // filters = filters.concat(this.givenSearchFilters);
            return filters;
        },
        esIndexFields() {
            let { groupName, servername, appProfileName, ruleName, serviceGroupName } = this.fields;
            // return { groupName, servername, appProfileName };
            let esIndexFieldsMap = {
                "rcm-nginxconfigs": { groupName, servername, appProfileName, description: {} },
                "rcm-app-profiles": { groupName, appProfileName, description: {} },
                "rcm-wafrules": { groupName, ruleName, description: {} },
                "rcm-servicegroup": {
                    groupName,
                    serviceGroupName,
                    description: {
                        render: (h, params) => {
                            return h(
                                "Input",
                                {
                                    props: {
                                        value: params.row.description,
                                    },
                                    on: {
                                        "on-blur": (event) => {
                                            if (params.row.description !== event.target.value) {
                                                params.row.description = event.target.value;
                                                updateDescription(
                                                    "servicegroup-description",
                                                    params.row.serviceGroupNameId,
                                                    {
                                                        groupName: params.row.groupName,
                                                        updateData: {
                                                            description: params.row.description,
                                                        },
                                                    }
                                                )
                                                    .then((result) => {
                                                        this.$Notice.success({
                                                            title: this.$i18n.t("global.success"),
                                                            desc: `${result.data.message}`,
                                                        });
                                                    })
                                                    .catch(function (error) {
                                                        this.$Notice.warning({
                                                            title: this.$i18n.t("global.error"),
                                                            desc: `${error}`,
                                                        });
                                                        this.$refs.RcmTable.getTableData();
                                                    });
                                            }
                                        },
                                    },
                                },
                                ""
                            );
                        },
                    },
                },
            };
            return esIndexFieldsMap[this.formData.esIndex];
        },
    },
    mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/Home/ResourceFinder.vue